import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { NavController } from "@ionic/angular";
import { cloneDeep } from "lodash-es";
import { Swiper, SwiperOptions } from "swiper/types";

@Component({
  selector: "app-slider",
  templateUrl: "./slider.component.html",
  styleUrls: ["./slider.component.scss"],
  standalone: false
})
export class SliderComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild("swiperSlideRef") swiperSlideRef: ElementRef;
  swiper?: Swiper;

  @Input() sliders: any[];
  @Input() options: SwiperOptions = {
    initialSlide: 0,
    grabCursor: true,
    speed: 700,
    zoom: true
  };
  @Input() pager: boolean = true;

  isSingleSlide: boolean = true;

  slidersData = [];

  constructor(
    private navController: NavController,
    private ref: ChangeDetectorRef
  ) { }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.ref.markForCheck();
    const swiperEl = this.swiperSlideRef.nativeElement;
    this.swiper = swiperEl.swiper;

    const options = removeInvalidSwiperProp(this.options);

    Object.assign(swiperEl, options);

    if (this.options.autoplay) {
      this.swiper.autoplay.running = true;

    }
    setTimeout(() => swiperEl.initialize(), 50);

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isSingleSlide = this.sliders.length < 2;
    if (this.isSingleSlide) {
      this.options = {
        ...this.options,
        grabCursor: false,
        loop: false,
      };
      delete this.options.autoplay;
      delete this.options.speed;
    }
    this.pager = this.pager && !this.isSingleSlide;

  }
  swipePrev() { }

  swipeNext() { }

  onClickSlide() {

  }

  goToUrl(slide) {

    const baseUrl = "app.copyfly.es";

    if (slide.url.includes(baseUrl) && !slide.targetBlank) {
      const path = slide.url
        .replace(/^https?:\/\/(www\.)?/i, "")
        .substring(baseUrl.length);
      this.navController.navigateForward(path);
    } else {
      !slide.targetBlank
        ? (window.location.href = slide.url)
        : window.open(slide.url, "_blank");
    }
  }
}

function removeInvalidSwiperProp(_options: SwiperOptions) {
  const options = cloneDeep(_options);
  Object.keys(options).forEach((key) => {
    if (options[key] === false) {
      delete options[key];
    }
  });
  return options;
}
